import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#A7A7B1",
      "fill-rule": "evenodd",
      d: "M13.246 6.95a5.246 5.246 0 1 1-10.492 0 5.246 5.246 0 0 1 10.492 0M8 11.104c.783 0 1.418-.207 1.418-.463 0-.255-.635-.463-1.418-.463s-1.418.208-1.418.463c0 .256.635.463 1.418.463",
      "clip-rule": "evenodd",
      style: {"fill":"color(display-p3 .6543 .6543 .6951)","fill-opacity":"1"}
    }, null, -1),
    _createElementVNode("path", {
      fill: "#6E6E7D",
      stroke: "#6E6E7D",
      "stroke-linecap": "round",
      "stroke-width": ".25",
      d: "m5.434 13.046-.082-.036-.06.066q-.123.132-.26.224l.069.101-.07-.101-.052.035-.058.025h0a.4.4 0 0 0-.217.236.437.437 0 0 0 .227.557c.846.337 1.915.533 3.07.533 1.153 0 2.223-.196 3.068-.533a.437.437 0 0 0 .227-.557.4.4 0 0 0-.217-.236l-.058-.025-.053-.035a1.5 1.5 0 0 1-.26-.224l-.06-.066-.082.036A6.4 6.4 0 0 1 8 13.584c-.91 0-1.778-.192-2.566-.538Z",
      style: {"fill":"color(display-p3 .4296 .4296 .4915)","fill-opacity":"1","stroke":"color(display-p3 .4296 .4296 .4915)","stroke-opacity":"1"}
    }, null, -1)
  ])))
}
export default { render: render }